import React from 'react';
import { useParams } from 'react-router-dom';
import { projectsData } from '../data/projectsData';
import MacBookMockup from '../components/MacBookMockup';
import IPhoneMockup from '../components/IPhoneMockup';
import ParallaxGallery from '../components/ParallaxGallery';

export default function Portfolio() {
  const { id } = useParams();
  
  const project = projectsData.find((p) => String(p.id) === String(id));

  if (!project) {
    return (
      <div className="pt-48 text-center text-black font-['Montserrat']">
        <h1 className="text-4xl mb-4">Project not found</h1>
        <p>The URL is looking for ID: <span className="text-red-500 font-bold">"{id}"</span></p>
        <p>Check if your URL says /portfolio/1 or just /portfolio</p>
      </div>
    );
  }

  const sectionClasses = "max-w-[85rem] w-full px-4 md:px-24 mx-auto font-['Montserrat',sans-serif]";

  return (
    <div className="bg-white min-h-screen">
      <div className='pt-48 mb-24'>
        <section className={sectionClasses}>
          {/* Main H1 for the page */}
          <h1 className="text-5xl md:text-8xl leading-tight font-medium [letter-spacing:-2px] md:[letter-spacing:-5px] capitalize">
            {project.title}
          </h1>
        </section>
      </div>

      <section className={`${sectionClasses} flex flex-col md:flex-row my-20 justify-between gap-16 md:gap-16`}>
        <div className='w-full md:w-1/3'>
          <div className='grid'>
            {/* UPDATED: Changed from p to h2 for SEO hierarchy */}
            <h2 className='uppercase font-medium text-zinc-500 text-xs mb-3 md:mb-8'>ROLE</h2>
            <hr className="h-px border-0 bg-zinc-300 mb-3 md:mb-8" />
            <p className='text-black text-lg md:text-xl'>{project.category}</p>
          </div>
        </div>   

        <div className='w-full md:w-1/3'>
          <div className='grid'>
            {/* UPDATED: Changed from p to h2 for SEO hierarchy */}
            <h2 className='uppercase font-medium text-zinc-500 text-xs mb-3 md:mb-8'>LOCATION & YEAR </h2>
            <hr className="h-px border-0 bg-zinc-300 mb-3 md:mb-8" />
            <p className='text-black text-lg md:text-xl whitespace-pre-line'>{project.location} {project.year}</p>
          </div>
        </div>   

        <div className='w-full md:w-1/3'>
          <div className='grid'>
            {/* UPDATED: Changed from p to h2 for SEO hierarchy */}
            <h2 className='uppercase font-medium text-zinc-500 text-xs mb-3 md:mb-8'>DESCRIPTION</h2>
            <hr className="h-px border-0 bg-zinc-300 mb-3 md:mb-8" />
            <p className='text-black text-lg md:text-xl'>{project.desc}</p>
          </div>
        </div>   
      </section>

      {project.deviceType === 'iphone' ? (
        <IPhoneMockup videoUrl={project.videoUrl} bgColor={project.bgColor} />
      ) : (
        <MacBookMockup videoUrl={project.videoUrl} />
      )}

      {/* Note: Ensure ParallaxGallery uses h2 or h3 for its internal titles */}
      <ParallaxGallery gallery={project.gallery} title={project.title} />

    </div>
  );
}